'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _reactDemo = require('react-demo');

var _reactDemo2 = _interopRequireDefault(_reactDemo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_PureComponent) {
  _inherits(Checkbox, _PureComponent);

  function Checkbox() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          checked = _this$props.checked,
          disabled = _this$props.disabled;


      if (!disabled) {
        onChange(!checked);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Checkbox, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          checked = _props.checked,
          children = _props.children,
          size = _props.size,
          disabled = _props.disabled,
          style = _props.style,
          className = _props.className;

      var icon = checked ? 'check-square-o' : 'square-o';

      var CX = (0, _classnames2.default)({ 'color-primary': checked }, { 'color-light-gray cursor-not-allowed': disabled }, { 'cursor-pointer': !disabled }, className);

      return _react2.default.createElement(
        'div',
        { onClick: this.handleClick, className: CX, style: style },
        _react2.default.createElement(_Icon2.default, { name: icon, size: size }),
        children
      );
    }
  }]);

  return Checkbox;
}(_react.PureComponent);

Checkbox.propTypes = {
  checked: _react.PropTypes.bool,
  onChange: _react.PropTypes.func.isRequired,
  disabled: _react.PropTypes.bool,
  size: _react.PropTypes.oneOf(_Icon2.default.sizes)
};
Checkbox.defaultProps = {
  checked: false,
  disabled: false
};

Checkbox.demo = function () {
  return _react2.default.createElement(
    _reactDemo2.default,
    {
      props: {
        size: _reactDemo.props.choices(_Icon2.default.sizes),
        onChange: _reactDemo.props.callback.log(),
        disabled: _reactDemo.props.bool(false),
        checked: _reactDemo.props.bool(false)
      } },
    function (props) {
      return _react2.default.createElement(
        Checkbox,
        props,
        ' Checkbox'
      );
    }
  );
};

exports.default = Checkbox;


//////////////////
// WEBPACK FOOTER
// ./~/react-fast-ui/lib/components/Checkbox.js
// module id = 393
// module chunks = 0